module.exports = "<app-view-trip-route></app-view-trip-route>"